export default function HourLabel(props) {
  const { color = '' } = props;

  return <span style={{ color: color, fontSize: `15vmin`, height: '15vmin', lineHeight: 0.6, }}>uur</span>;
}
